import Vue from "vue/dist/vue.esm";
import Modal from "/shared/modal.vue";
import cookie from "/utils/cookie";
import { initModalVideo } from "/modules/modal-video";

const nodes = document.querySelectorAll("[data-modal]");
for (let i = 0; i < nodes.length; i++) {
  const el = nodes[i];
  const id = el.getAttribute("data-modal");

  if (cookie(`modal-${id}`)) {
    continue;
  }

  const stepsNodes = el.querySelectorAll("[data-modal-step]");
  let content;
  if (stepsNodes.length <= 0) {
    content = el.innerHTML;
  }
  const modifiers = el.dataset.modalModifiers ? el.dataset.modalModifiers.split(",") : [];

  new Vue({
    name: "ModalsInit",
    el,
    render: h => h(Modal, {
      props: {
        id,
        content,
        timeout: el.dataset.modalTimeout,
        timeoutClose: el.dataset.modalTimeoutClose,
        cookie: el.dataset.modalCookie,
        trackingName: el.dataset.modalPiwikEventCategory,
        openActionName: el.dataset.modalPiwikEventAction,
        fixedSizes: el.dataset.modalFixedSizes === "true",
        modifiers
      }
    },
    [...stepsNodes].map(a => h("div", {
      slot: a.dataset.modalStep,
      domProps: {
        innerHTML: a.innerHTML
      }
    })))
  });

  if (modifiers.indexOf("video") >= 0) {
    initModalVideo(id, el.dataset.modalYoutube);
  }
}
